<template lang="html">
  <div>
    <div>
        <a @click="editarMostrar">
            <slot name="ico"></slot>
            {{ titulo }}
            <i class="fa fa-angle-up" aria-hidden="true" v-if="mostrar" ></i>
            <i class="fa fa-angle-down" aria-hidden="true" v-else></i>
            <span class="text-dica" v-show="opcional">(Opcional)</span>
        </a>
    </div>
     <div v-show="mostrar">
       <br>
       <slot name="conteudo"></slot>
       <br>
     </div>
  </div>
</template>
<script>

export default {

  name: 'ver-mais',

  props:{

     iniciaAberto:{
       default: false
     },
     titulo : {
       default: ''
     },
     opcional : {
       default: true
     }

  },

  data(){
    return{
      mostrar: false
    }
  },

  created(){
      this.mostrar = _.clone(this.iniciaAberto)
  },

  methods:{
    editarMostrar(){
        this.mostrar = !this.mostrar
        // console.log(this.mostrar);
    }
  }

}

</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/basicos/VerMais.vue